import Link from "next/link";

interface TagBadgeProps {
    name: string;
    slug: string;
    color: string;
    category?: string;
    clickable?: boolean;
    size?: "sm" | "md";
}

export default function TagBadge({
    name,
    slug,
    color,
    clickable = true,
    size = "sm",
}: TagBadgeProps) {
    const sizeClasses = size === "sm"
        ? "text-xs px-2 py-0.5"
        : "text-sm px-3 py-1";

    const baseClasses = `inline-flex items-center rounded-full font-medium transition-all ${sizeClasses}`;

    const style = {
        backgroundColor: `${color}20`,
        color: color,
        borderColor: `${color}40`,
    };

    if (clickable) {
        return (
            <Link
                href={`/inby?tag=${slug}`}
                className={`${baseClasses} border hover:opacity-80`}
                style={style}
            >
                {name}
            </Link>
        );
    }

    return (
        <span className={`${baseClasses} border`} style={style}>
            {name}
        </span>
    );
}
